import axios from "axios";
import React, { useEffect, useState } from "react";

const formatHistoryDate = (record) => {
  const dateValue = record?.updatedAt || record?.createdAt || record?.date;
  if (!dateValue) return "-";
  const d = new Date(dateValue);
  if (Number.isNaN(d.getTime())) return "-";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} à ${hours}:${minutes}`;
};

const ActivityTimestampBanners = ({ history, skipFetch = false, onHistoryLoaded }) => {
  const [fetchedHistory, setFetchedHistory] = useState(null);

  useEffect(() => {
    if (skipFetch) return;

    async function getStoresHistoryDates() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/file-history/data`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("amira-token")}`,
            },
          }
        );
        const data = response.data;
        if (data.status === "Success" && data.data) {
          setFetchedHistory(data.data);
          if (onHistoryLoaded) {
            onHistoryLoaded(data.data);
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    getStoresHistoryDates();
  }, [skipFetch, onHistoryLoaded]);

  const activeHistory = history || fetchedHistory || {};
  const preparation = activeHistory.preparation || {};
  const dashboardUpdate = activeHistory.dashboard_update || {};
  const labelsCount = activeHistory.labels_count || {};
  const savCount = activeHistory.sav_count || {};

  return (
    <div className="d-flex flex-wrap justify-content-center gap-3 mb-4 activity-timestamp-banners">
      <div className="history-date-containers text-bold">
        <div className="history-date">
          Mise à jour Prépa: {formatHistoryDate(preparation)}
        </div>
        <div className="history-date">
          Mise à jour du Dashboard: {formatHistoryDate(dashboardUpdate)}
        </div>
      </div>
      <div className="history-date-containers text-bold">
        <div className="history-date">
          Mise à jour étiquettes: {formatHistoryDate(labelsCount)}
        </div>
        <div className="history-date">
          Mise à jour S.A.V: {formatHistoryDate(savCount)}
        </div>
      </div>
    </div>
  );
};

export default ActivityTimestampBanners;
